// import tailorApi from './dev';  // dev
import tailorApi from './prod'; // prod

export default tailorApi;
